import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RecoveryService {
  http = inject(HttpClient);

  generatePassword(userName: string): Observable<void> {
    return this.http.post<void>(`recovery/generate?userName=${encodeURIComponent(userName)}`, userName);
  }

  changePassword(id: string, password: string, confirmPassword: string): Observable<void> {
    return this.http.post<void>(`recovery/password?id=${id}`, { password, confirmPassword });
  }
}
